"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIndexUtils = void 0;
exports.ZIndexUtils = {
    getDistance(entity, point) {
        const min = Math.abs(((point.z - entity.z) - entity.radius));
        const max = Math.abs(((point.z - entity.z) + entity.radius));
        return Math.min(min, max);
    },
    getYRotationMatrix(angle) {
        const angleInRad = (angle * Math.PI) / 180;
        const cos = Math.cos(angleInRad);
        const sin = Math.sin(angleInRad);
        return [cos, 0, sin, 0, 1, 0, -(sin), 0, cos];
    },
    multiply4x4Matrix(vector4D, vector3D) {
        const x = ((vector3D.x * vector4D[0]) + (vector3D.y * vector4D[3])) + (vector3D.z * vector4D[6]);
        const y = ((vector3D.x * vector4D[1]) + (vector3D.y * vector4D[4])) + (vector3D.z * vector4D[7]);
        const z = ((vector3D.x * vector4D[2]) + (vector3D.y * vector4D[5])) + (vector3D.z * vector4D[8]);
        return { x, y, z };
    }
};
